export function base64URLEncode(str: string): string {
    const b64 = btoa(str);
    const encoded = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    return encoded;
}
